
import { defineComponent, PropType } from 'vue';
import { primitiveMessages, useNodeCanvasStore } from '../store';
import { removeElement } from '@/modules/globalModule/components/helperMethods';
import SearchableDropDown from '@/modules/globalModule/components/SearchableDropDown.vue';
import { Message, MessageField } from './storeClasses/message';
import { useGlobalStore } from '@/modules/globalModule/store';

interface State {
  ncStore: any;
  globalStore: any;
  editModeParams: Array<string>; // array of ServiceParamer ids
  constParams: Array<string>;
}

export default defineComponent({
  name: 'AddNewMsgType',
  emits: ['editServiceEnd'],
  data(): State {
    return {
      ncStore: useNodeCanvasStore(),
      globalStore: useGlobalStore(),
      editModeParams: [],
      constParams: []
    };
  },
  components: {
    SearchableDropDown
  },

  methods: {
    onExitModal() {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg) {
        ncStore.editingMsg = undefined;
        this.editModeParams = [];
        return;
      }
      this.save();
      ncStore.editingMsg = undefined;
      this.editModeParams = [];
    },
    save() {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg || !ncStore.packageId) return;
      const globalStore = useGlobalStore();
      const pkg = globalStore.getPackage(ncStore.packageId);
      if (!pkg) return;
      pkg.msgs = pkg.msgs.filter((msg) => msg.id !== ncStore.editingMsg?.id);
      pkg.msgs.push(ncStore.editingMsg);
      globalStore.saveData();
    },
    getPrimitiveMessages() {
      return primitiveMessages;
    },
    /**
     * @param request true if adding to request list, false if response list
     */
    addNewParam() {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg) return;
      const newParam: MessageField = new MessageField(
        primitiveMessages[0].id,
        ''
      );
      ncStore.editingMsg.fields.push(newParam);
    },
    /**
     * Toggles whether currently editing this parameter or not
     * @param id
     */
    onEditParam(id: string) {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg) return;
      // if already editing param then disable editing and return
      if (this.editModeParams.includes(id)) {
        removeElement(this.editModeParams, id);
        if (this.constParams.includes(id)) removeElement(this.constParams, id);
        return;
      }
      this.editModeParams.push(id);
      if (
        this.ncStore.editingMsg.fields.find(
          (param: MessageField) => param.id === id
        ).constantValue !== undefined
      ) {
        this.constParams.push(id);
      }
    },
    onDup(id: string) {},
    onDeleteParam(id: string) {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg) return;
      ncStore.editingMsg.fields = ncStore.editingMsg.fields.filter(
        (param: MessageField) => param.id !== id
      );
    },
    /**
     *
     * @param request - true if request, false if response
     * @param id - id of the message field to change
     * @param msg - new message type to change to
     */
    chooseParamMsgType(id: string, msg: Message) {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg) return;
      if (!msg) return;
      ncStore.editingMsg.fields.find(
        (reqParam: MessageField) => reqParam.id === id
      )!.msg = msg.id;
    },
    onConstBoxClicked(param: MessageField) {
      if (param.constantValue === undefined) param.constantValue = '';
      else {
        param.constantValue = undefined;
        if (this.constParams.includes(param.id))
          removeElement(this.constParams, param.id);
      }
    },
    getMessageFieldName(field: MessageField) {
      const globalStore = useGlobalStore();
      const msgType = globalStore.getMessage(field.msg);
      if (msgType) return msgType.name;
      return '';
    },
    openCode() {
      const ncStore = useNodeCanvasStore();
      if (!ncStore.editingMsg) {
        this.$router.push(`/codeView/${this.$route.params.workspaceID}`);
        return;
      }
      this.save();
      this.$router.push(
        `/codeView/${this.$route.params.workspaceID}?elemId=${ncStore.editingMsg.id}`
      );
    }
  }
});
